// The one GenServ signature block, as pure functions the server (api/_lib/genservSignature.js) and the browser composer (userSignatures.getSignature) both use, so the preview
// Shane sees in a composer and the HTML that is sent can never differ: his scripture (italic quote, bold "(NIV)" reference), Shane Deason, GenServ Generator Maintenance, the phone,
// the GenServ mailbox hello@genserv.co (never Shane's Well Repd address) and the large wordmark (260px). Replies go to that same mailbox, the one the email is sent from.
export const GENSERV_SIGNATURE_PARTNER_ID = '9255e983-c266-4633-91a6-ba6ee31af481';
export const GENSERV_WORDMARK_FILE = '/brand/genserv/genserv-wordmark.png';
export const GENSERV_SIGNATURE_EMAIL = 'hello@genserv.co';

/**
 * The scripture part of the closing block, as two lines: the italic quote exactly as stored, then the reference in bold on the next line. The "Regards, Shane" lead-in is dropped, and a
 * reference stored without "(NIV)" gets it appended in this render only (the stored row is Shane's data and is never changed). '' when the block has no scripture.
 */
export function scriptureFrom(content) {
  const text = String(content || '');
  const m = /(<em[\s>][\s\S]*?<\/em>)([\s\S]*)$/i.exec(text);
  if (!m) return '';
  const quote = m[1].replace(/\s+/g, ' ').trim();
  let ref = m[2].replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
  if (ref && !/\(NIV\)/i.test(ref)) ref = `${ref} (NIV)`;
  return `<div>${quote}</div>${ref ? `<div><strong>${ref}</strong></div>` : ''}`;
}

/** The signature block as email HTML. Plain, left aligned, on the white page; the wordmark is large (260px). */
export function buildGenservSignature({ scripture = '', phone = '', baseUrl = 'https://charlie.wellrepd.com' } = {}) {
  const wordmark = `${String(baseUrl).replace(/\/+$/, '')}${GENSERV_WORDMARK_FILE}`;
  return `<div style="margin-top:22px;font-size:14px;line-height:1.5;color:#1a1a1a;">`
    + (scripture ? `<div style="margin:0 0 14px 0;">${scripture}</div>` : '')
    + '<div><strong>Shane Deason</strong></div>'
    + '<div>GenServ Generator Maintenance</div>'
    + `<div>${phone || '(936) 446-8155'}</div>`
    + `<div><a href="mailto:${GENSERV_SIGNATURE_EMAIL}" style="color:#1a1a1a;text-decoration:none;">${GENSERV_SIGNATURE_EMAIL}</a></div>`
    + `<div style="margin-top:10px;"><img src="${wordmark}" width="260" alt="GenServ" style="display:block;width:260px;max-width:100%;height:auto;border:0;"></div>`
    + '</div>';
}
